import { FC } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import RobotIcon from '../../assets/icons/robot.svg?react';
import { Button } from '../../components/buttons';
import { RootState } from '../../reducers';
import { AssistantChat } from './AssistantChat';
import { toggleAssistant } from './assistantSlice';

export const Assistant: FC = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.assistant.isOpen);

  const handleClick = () => dispatch(toggleAssistant());

  const component = (
    <div className='absolute bottom-16 right-5 z-[9999] flex flex-col items-end gap-4'>
      {isOpen ? <AssistantChat handleClose={handleClick} /> : null}
      <Button onClick={handleClick} className='relative z-50 size-fit rounded-full !ring-offset-0 focus:!ring-0'>
        <RobotIcon />
      </Button>
    </div>
  );

  return createPortal(component, document.getElementById('root-body'));
};
